var loginCtrl = function (restSvc, ifacsSvc, iFastWebContextRootSvc, $location, $cookies, $rootScope, $analytics, loginConstant) {
  "use strict";

  this.restSvc = restSvc;
  this.ifacsSvc = ifacsSvc;
  this.iFastWebContextRootSvc = iFastWebContextRootSvc;
  this.location = $location;
  this.cookies = $cookies;
  this.rootScope = $rootScope;
  this.analytics = $analytics;
  this.tempPassChgOk=($location.search().pcs && $location.search().pcs.toUpperCase() ==="YES"?true:false);
  var privateConstants = {
    CHPWD_REQD  : "CHPWD_REQD",
    NONE        : "NONE",
    LOCKED      : "LOCKED",
    LOCKEDENABLE: "LOCKEDENABLE",
    ENABLE      : "ENABLE",
    LINKED_URL  : "<LINKED_URL>"
  };
  this.loginConstant = angular.extend(privateConstants, loginConstant);
  this.registerLink = "#userSelfRegistration";
  this.onLoad();
};

loginCtrl.prototype.loadSelfRegistration = function (path) {
  "use strict";
  this.location.path(path);

};

loginCtrl.prototype.onLoad = function () {
  "use strict";


  this.language = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
  this.language = this.language.substring(0, 2);

    // check if this is non-client user for slf
    // isClientUser only tells if the user is trying to login from the client user page or the non-client user page.
  var loginPath = this.location.absUrl();
  if (0 > loginPath.indexOf("nonclientlogin")) {
    this.isClientUser = "true";
  } else {
    this.isClientUser = "false";
  }

    
  if (0 < this.location.absUrl().indexOf("error") || 0 < this.location.absUrl().indexOf("j_security_check")) {
        // login failed. get isClientUser from cookies
    this.isClientUser = this.cookies.get(this.loginConstant.ISCLIENTUSER);

    if (true !== this.rootScope.loginFailed) {
      this.rootScope.loginFailed = true;
      this.onLoginError();
    } else {
            // reloading the login view. clear error msg.
      this.rootScope.reloadLoginView = true;
    }
    this.saveUsername = this.cookies.get(this.loginConstant.SAVEUSERNAME);// use the cookies value in the case of login error
  } else {
    this.rootScope.loginFailed = false;
    this.cookies.put(this.loginConstant.ISCLIENTUSER, this.isClientUser);
    this.saveUsername = false;// This will be changed as per the config value from DB in passClientLoginSetting method
  }

  if ("true" === this.cookies.get(this.loginConstant.SAVEUSERNAME)) {
    this[this.loginConstant.JUSERNAME] = this.cookies.get(this.loginConstant.JUSERNAME);
    this.saveUsername = true;
  }
  this.timeout = this.cookies.get(this.loginConstant.TIMEOUT) === "true";
  this.cookies.put(this.loginConstant.TIMEOUT, false);
  this.apiOrConfigFailed = false;

  this.onUsernamePwdChange();
  if (!this.rootScope.loginFailed) {
    this.loadClientLoginSetting();
  }
    //DFT0116861
	var urlRetrieved = window.location.href;

	if (urlRetrieved.includes('resetPwd')) {
		var firstPart = urlRetrieved.substring(0, urlRetrieved.lastIndexOf('#!'));
		var secpart = '/#!/resetPwd';
		var newlyFormedUrl = firstPart + secpart;
		window.location.href = newlyFormedUrl;
	} else {
		// Remove the ?token= part from the URL
		var tokenIndex = urlRetrieved.indexOf('?token=');
		if (tokenIndex !== -1) {
			var baseUrl = urlRetrieved.substring(0, tokenIndex);
			var hashIndex = urlRetrieved.indexOf('#!');
			if (hashIndex !== -1) {
				var hashPart = urlRetrieved.substring(hashIndex);
				var finalUrl = baseUrl + hashPart;
				window.location.href = finalUrl;
			}
		}
	}

};

loginCtrl.prototype.isApiOrConfigFailed = function (ctrl) {
  "use strict";
  var url = ctrl.location.absUrl();
  var errCdIndex = url.indexOf("errCd=");
  var result = false;
    // console.log("Login failed: isApiOrConfigFailed " + ctrl.errorCode + " " + errCdIndex);

  if (-1 !== errCdIndex) {
    var errCd = decodeURIComponent(url.substring(errCdIndex + 6, url.indexOf("#")));

    this.errorMessage = ctrl.userAdminSettingMap[errCd];
    result = true;
    }
    else if (!!ctrl.errorCode)
    {
    if (!!ctrl.userAdminSettingMap[ctrl.errorCode + ctrl.loginConstant.ENABLE] && 
        ctrl.userAdminSettingMap[ctrl.errorCode + ctrl.loginConstant.ENABLE].toUpperCase() == "TRUE")
        {
      this.errorMessage = ctrl.userAdminSettingMap[ctrl.errorCode];       
      result = true;    
        }
        else {
      this.errorCode = "";
    }
  }

  return result;

};

loginCtrl.prototype.isLoginFailed = function () {
  "use strict";
  return this.rootScope.loginFailed && true !== this.rootScope.reloadLoginView &&
           (!!!this.errorCode || this.errorCode.length <= 0);
};

loginCtrl.prototype.loadClientLoginSetting = function (redirect) {
  "use strict";
  var clientCd = this.iFastWebContextRootSvc.clientCode;
  var langCd = this.language;
  var rest = this.restSvc.query({type: "configuration", method: "retrieveClientLoginSetting"}, {"clientCd": clientCd, "language": langCd});
  rest.$promise.then(this.passClientLoginSetting(this, redirect), this.fail);
};

loginCtrl.prototype.passClientLoginSetting = function (ctrl, redirect) {
  "use strict";
  return function (result) {
    ctrl.userAdminSettingMap = result.userAdminSettingMap;
    ctrl.languageMap = result.languageMap;
       
    ctrl.language = ctrl.userAdminSettingMap.language;
    ctrl.apiOrConfigFailed = ctrl.isApiOrConfigFailed(ctrl);
    ctrl.tempPassChgMsg = ctrl.userAdminSettingMap.passwdchgmsg;
    var redirectUrl;

    if (ctrl.userAdminSettingMap.investorSelfRegisterClient.toUpperCase() === "TRUE") {
      ctrl.registerLink = "#userTypeSelection";
    }
    if (redirect) {
      redirectUrl = ctrl.userAdminSettingMap.redirectUrl;
      if (redirectUrl) {
        location.href = redirectUrl;
      }
    }

    if (!redirectUrl) {
      ctrl.isLoaded = true;
    }
    if (ctrl.userAdminSettingMap.linkedClient !== undefined && ctrl.userAdminSettingMap.linkedClient !== null && ctrl.userAdminSettingMap.linkedClient !== '') {
        	ctrl.setLinkedClientUrl(ctrl);
    }
        
    if (!ctrl.saveUsername && ctrl.userAdminSettingMap.saveMyUsernameEnabled !== undefined && ctrl.userAdminSettingMap.saveMyUsernameEnabled !== null) {
      if (ctrl.userAdminSettingMap.saveMyUsernameEnabled.toUpperCase() === "TRUE") {
            	ctrl.saveUsername = true;
      } 
    }
        
  };

};
loginCtrl.prototype.forgotUIDClick=function (ctrl) {
	var url=window.location.href;
  var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
  var secondPart,firstPart,redirectUrl;
  if(ifstwbprinUrlIndex > 0){
    secondPart= "ifastweb/login.html#!/forgotUid";
	  firstPart= url.substring(0,url.indexOf("ifastweb"));
	  redirectUrl=firstPart+secondPart;
      window.location.href=redirectUrl
  }else{
    secondPart= "/login.html#!/forgotUid";
	firstPart= url.substring(0,url.indexOf("/login.html"));
	redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }
	
};

loginCtrl.prototype.forgotPWDClick=function (ctrl) {
  var url=window.location.href;
  var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
  var secondPart,firstPart,redirectUrl;
  if(ifstwbprinUrlIndex > 0){
    secondPart= "ifastweb/login.html#!/forgotPwd";
	  firstPart= url.substring(0,url.indexOf("ifastweb"));
	  redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }else{
    secondPart= "/login.html#!/forgotPwd";
	  firstPart= url.substring(0,url.indexOf("/login.html"));
	  redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }
};

loginCtrl.prototype.regClick=function (ctrl) {
  var url=window.location.href;
  var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
  var secondPart,firstPart,redirectUrl;
  if(ifstwbprinUrlIndex > 0){
    secondPart= "ifastweb/login.html#!/userSelfRegistration";
	  firstPart= url.substring(0,url.indexOf("ifastweb"));
	  redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }else{
    secondPart= "/login.html#!/userSelfRegistration";
	  firstPart= url.substring(0,url.indexOf("/login.html"));
	  redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }
};

loginCtrl.prototype.setLinkedClientUrl = function (ctrl) {
  "use strict";
  var linkedClient = ctrl.userAdminSettingMap.linkedClient;
  var adnlInfo = ctrl.userAdminSettingMap.adnlInfo;
  var clientUrl = ctrl.location.absUrl();
  clientUrl = clientUrl.replace(ctrl.iFastWebContextRootSvc.clientCode, linkedClient);
  adnlInfo = adnlInfo.replace(this.loginConstant.LINKED_URL, clientUrl);
  ctrl.userAdminSettingMap.adnlInfo = adnlInfo;
};

loginCtrl.prototype.showUserSelfRegistrationLink = function () {
  "use strict";
  if (this.userAdminSettingMap.userSelfRegistrationLink !== undefined && this.userAdminSettingMap.userSelfRegistrationLink !== null) {
    if (this.userAdminSettingMap.userSelfRegistrationLink.toUpperCase() === "TRUE") {
      return true;
    } else {
      return false;
    }
    }
    else {
    return false;
  }
};
loginCtrl.prototype.onSubmit = function (event) {
  "use strict";

    // track analytics
  this.analytics.eventTrack("Login", {
    "usernameValue"     : this[this.loginConstant.JUSERNAME],
    "usernameText"      : this[this.loginConstant.JUSERNAME],
    "usernameFieldName" : "login",
    "usernameObjectName": "ClientLoginSetting",
    "module"            : "Logins"
  });
    
  if (this.saveUsername) {
    	this.cookies.put(this.loginConstant.SAVEUSERNAME, this.saveUsername);
  }
  this.cookies.put(this.loginConstant.JUSERNAME, this[this.loginConstant.JUSERNAME]);


  this.cookies.put(this.loginConstant.NONSSOUSER, "true");

  var form = event.currentTarget.form;
 
  form.action = "j_security_check";
  form.submit();
};

loginCtrl.prototype.onLoginError = function () {
  "use strict";

  this.ifacsSvc.loginError({ method: "login_error"},
        {})
        .$promise.then(this.passLoginError(this));
};

loginCtrl.prototype.passLoginError = function (controller) {
  "use strict";

  window.console.log("Login error request is submitted.");

  return function (response) {
    var responseCode = response.code;
    window.console.log("Response from ifacs:" + responseCode);
        
        switch (responseCode)
        {
    case controller.loginConstant.CHPWD_REQD :
      window.console.log("Change password required.");            
      controller.rootScope[controller.loginConstant.JUSERNAME] = controller.cookies.get(controller.loginConstant.JUSERNAME);
      controller.location.url("/changePassword");
      break;
    case controller.loginConstant.NONE :                
      window.console.log("Login: status code " + responseCode);
      controller.cookies.put(controller.loginConstant.TIMEOUT, true);
      window.history.back();
      break;
    case controller.loginConstant.LOCKED :
      window.console.log("Login: status code " + responseCode);
      controller.errorCode = responseCode;    
      controller.loadClientLoginSetting(true);
      break;
    default:
      window.console.log("default Login : status code " + responseCode);
      controller.loadClientLoginSetting(true);
      break;
                
    }
  };
};

loginCtrl.prototype.onUsernamePwdChange = function () {
  "use strict";
  if (null !== this[this.loginConstant.JUSERNAME] && undefined !== this[this.loginConstant.JUSERNAME] &&
        0 < this[this.loginConstant.JUSERNAME].trim().length &&
        null !== this[this.loginConstant.JPASSWORD] && undefined !== this[this.loginConstant.JPASSWORD] &&
        0 < this[this.loginConstant.JPASSWORD].length) {
    this.disableSubmit = false;
  } else {
    this.disableSubmit = true;
  }
};

loginCtrl.prototype.changeLanguage = function (){
	"use strict";
	this.rootScope.language = this.language;
	this.loadClientLoginSetting();
}

loginCtrl.prototype.enableLanguageSelection = function(){
	"use strict";
	return (this.userAdminSettingMap.enableLanguageSelectionOnLoginPage !== undefined && 
			this.userAdminSettingMap.enableLanguageSelectionOnLoginPage !== null && 
			this.userAdminSettingMap.enableLanguageSelectionOnLoginPage.toUpperCase() === "TRUE");
}

loginCtrl.prototype.handleKeyDown = function(event){
	const arrowKeys = ['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'];
	if(arrowKeys.includes(event.key)){
		event.preventDefault();
	}
}


loginCtrl.$inject = ["restSvc", "ifacsSvc", "iFastWebContextRootSvc", "$location", "$cookies", "$rootScope", "$analytics", "loginConstant"];
angular.module("iFAST.login")
    .constant("loginConstant",{
      "JUSERNAME"   : "j_username",
      "JPASSWORD"   : "j_password",
      "NEWPASSWORD" : "new_password",
      "CONFPASSWORD": "conf_password",
      "SAVEUSERNAME": "saveUsername",
      "ISCLIENTUSER": "isClientUser",
      "TIMEOUT"     : "timeout",
      "NONSSOUSER"  : "nonSsoUser"
    })
    .controller("loginCtrl", loginCtrl);


// WEBPACK FOOTER //
// ./WebContent/src/login/ifastLogin-controller.js